export default __webpack_public_path__ + "media/images/images/flags/la-a6b39d7886175ee723ec907a14ef3ec1.png";